import React from 'react';
import { useTranslation } from 'react-i18next';
import {Block, Title} from '../../../components/components';
import { useHistory } from 'react-router';
import useCustomTable from "../../../components/tables/useCustomTable";
import Table from "../../../components/tables/Table";
import Pagination from "../../../components/tables/Pagination";
import FormButton from "../../../components/forms/FormButton";
import {TableSearchRow} from "../../../components/tables/TableSearch";
import {useGetUsersQuery} from "../../../api/userApiSlice";
import { Loader } from '../../../components/components';

function PublisherUsersList(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const {data: users = [], isSuccess, isLoading} = useGetUsersQuery()

  const usersColumns = [{
    Header: t('users.firstName'),
    accessor: 'firstName',
  },{
    Header: t('users.lastName'),
    accessor: 'lastName',
  },{
    Header: 'Email',
    accessor: 'email',
  },{
    Header: t('users.createdAt'),
    accessor: 'createdAt',
    format: 'date',
  },{
    Header: t('users.lastConnection'),
    accessor: 'currentSignInAt',
    format: 'date',
  }];

  const tableOptions = {
    sortable: true,
    filterable: true,
    paginate: true
  };

  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable(tableOptions)

  const showUser = function(data) {
    history.push(`/users/${data.slug}`);
  }

  return (
    <>
      <Title main={t("menu.users")} group={true} >
        <FormButton new />
      </Title>
      <TableSearchRow {...tableSearchProps}/>
      <Block className="mb-0">
        <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
          <Table
            data={users}
            columns={usersColumns}
            onRowClick={showUser}
            {...tableProps} />
          </Loader>
        </Block>
      <Pagination {...paginationProps}/>
    </>
  )
}

export default PublisherUsersList
